import { FinanceRow } from "@/types";
import { FinanceTableHeader } from "@/utils/financeTableHeaders";

// Finance-specific utility functions
export const getCellValue = (header: FinanceTableHeader, row: FinanceRow) => {
  if (header.getValue) {
    return header.getValue(row);
  }
  return row[header.key] || "";
};

// Finance-specific data validation and formatting functions can be added here
export const formatFinanceAmount = (amount: string | number): string => {
  const numAmount = typeof amount === "string" ? parseFloat(amount) : amount;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(numAmount || 0);
};

export const isFinanceReviewStatus = (status: string): boolean => {
  return status === "finance_review";
};
